import { FieldProps, TextFieldWithPrefix, useFieldHelper } from 'framework/ui/field';
import { useDateService } from 'framework/utils';
import UpdateIcon from '@mui/icons-material/Update';
import { useShowContext } from 'framework/show';
import { RISK_STATUS } from 'domain/shared/newProject';

type LastUpdateFieldProps = FieldProps & {
  createSource: string;
  isRiskActive?: boolean;
};

const LastUpdateField = (props: LastUpdateFieldProps) => {
  const { createSource, updateSource, isRiskActive = false } = props;
  const { getValue: getCreatedAt } = useFieldHelper<string>({ source: createSource });
  const { getValue: getUpdatedAt } = useFieldHelper<string>({ source: updateSource });
  const { datesDifference, getToday } = useDateService();
  const { data } = useShowContext();

  const createdAt = getCreatedAt();
  const updatedAt = getUpdatedAt();
  const actualDate = updatedAt || createdAt;

  if (isRiskActive && data.status !== RISK_STATUS.ACTIVE) {
    return null;
  }

  return (
    <TextFieldWithPrefix
      tooltipProps={{
        title: 'Last update',
        children: (
          <div>
            <UpdateIcon sx={{ color: 'text.secondary' }} />
          </div>
        ),
      }}
      label=""
      value={actualDate ? datesDifference(getToday(), actualDate) : ''}
      {...props}
    />
  );
};

export default LastUpdateField;
